module.exports = __webpack_public_path__ + "img/introducePageSeven_show_eight.ff78ae3d.jpg";